module.exports = __webpack_public_path__ + "static/media/22ESCWA4.5e12ecd3.jpg";